import type { IncomingCall } from '@/api/callApi'
import { asSnowflakeId } from '@/types/snowflake'

/** The same wire payload arrives through WebSocket and recovery snapshots. */
export function mapIncomingCall(raw: Record<string, unknown>): IncomingCall {
  return {
    callSid: String(raw.call_sid),
    callerNumber: String(raw.caller_number),
    callLogId: asSnowflakeId(String(raw.call_log_id)),
    guestId: raw.guest_id != null ? asSnowflakeId(String(raw.guest_id)) : null,
    guestName: (raw.guest_name as string | null) ?? null,
    reservationId: raw.reservation_id != null ? asSnowflakeId(String(raw.reservation_id)) : null,
    listingName: (raw.listing_name as string | null) ?? null,
    checkIn: (raw.check_in as string | null) ?? null,
    checkOut: (raw.check_out as string | null) ?? null,
    status: 'ringing',
  }
}
